export default __webpack_public_path__ + "static/WhatsAppButtonWhiteSmall-4d17c2437da86ddd225b14030fc55bd4.svg";